/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addresshiddenstatus2Inputs */

const en_addresshiddenstatus2 = /** @type {(inputs: Addresshiddenstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address only for confirmed guests`)
};

const de_addresshiddenstatus2 = /** @type {(inputs: Addresshiddenstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse nur für bestätigte Gäste`)
};

/**
* | output |
* | --- |
* | "Address only for confirmed guests" |
*
* @param {Addresshiddenstatus2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const addresshiddenstatus2 = /** @type {((inputs?: Addresshiddenstatus2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addresshiddenstatus2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addresshiddenstatus2(inputs)
	return de_addresshiddenstatus2(inputs)
});
export { addresshiddenstatus2 as "addressHiddenStatus" }